import VideoCallBookingInformation from './VideoCallBookingInformation'

export default VideoCallBookingInformation
